import Attachment from "components/base/Attachment/Attachment";

export default Attachment;
